import { caaMetricsRepositoryAdapter } from '../../infra/repositories/caaMetricsRepositoryAdapter'

export function GetOperationalCAAMetricsPatientMonthCase(
  repository: ReturnType<typeof caaMetricsRepositoryAdapter>
) {
  return async (params: {
    personaName?: string
    month: number
    year: number
  }) => {
    return await repository.getOperationalCAAMetricsPatientMonth(params)
  }
}
